const useModal = () => {
  const openModal = async modalPageId => {};

  const closeModal = async modalPageId => {};

  return {
    openModal,
    closeModal
  };
};

export default useModal;
